import type { RouteRecordRaw } from 'vue-router';

/**
 * phase-1.0 主干预热阶段的本地调试路由集合（external 静态注册）。
 * 仅 dev 阶段使用：
 *  - hideInMenu 不出现在菜单中
 *  - ignoreAccess 跳过登录态校验，便于本地/Playwright 直接访问
 *  - 不挂 BasicLayout，避免 layout 内部用户信息依赖触发 logout 重定向
 * 命名 _dev 前缀避免与业务模块冲突。
 */
const routes: RouteRecordRaw[] = [
  {
    component: () => import('#/views/_dev/warehouse-test.vue'),
    meta: {
      hideInBreadcrumb: true,
      hideInMenu: true,
      ignoreAccess: true,
      title: 'warmup-4 仓库下拉调试',
    },
    name: '_DevWarehouseTest',
    path: '/_dev/warehouse-test',
  },
];

export default routes;
